import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAnonymous_uploadUpload_token = z.any()
export type TagsPostAnonymous_uploadUpload_token = z.infer<typeof tagsPostAnonymous_uploadUpload_token>

export const descriptionPostAnonymous_uploadUpload_token = z.any()
export type DescriptionPostAnonymous_uploadUpload_token = z.infer<typeof descriptionPostAnonymous_uploadUpload_token>

export const paramsPostAnonymous_uploadUpload_token = z.object({ "token": z.string() })
export type ParamsPostAnonymous_uploadUpload_token = z.infer<typeof paramsPostAnonymous_uploadUpload_token>

export const consumesPostAnonymous_uploadUpload_token = z.any()
export type ConsumesPostAnonymous_uploadUpload_token = z.infer<typeof consumesPostAnonymous_uploadUpload_token>

export const bodyPostAnonymous_uploadUpload_token = z.object({ "attachment": z.union([z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string().optional(), "file": z.any(), "type": z.string().optional() }), z.array(z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string().optional(), "file": z.any(), "type": z.string().optional() }))]) })
export type BodyPostAnonymous_uploadUpload_token = z.infer<typeof bodyPostAnonymous_uploadUpload_token>

interface IPostAnonymous_uploadUpload_token extends BaseMethodType {
  tags: TagsPostAnonymous_uploadUpload_token,
  description: DescriptionPostAnonymous_uploadUpload_token,
  params: ParamsPostAnonymous_uploadUpload_token,
  consumes: ConsumesPostAnonymous_uploadUpload_token,
  body: BodyPostAnonymous_uploadUpload_token
}
export const URL = '/anonymous-upload/upload/:token'
export const validation = {
  post: {
    tags: tagsPostAnonymous_uploadUpload_token,
    description: descriptionPostAnonymous_uploadUpload_token,
    params: paramsPostAnonymous_uploadUpload_token,
    consumes: consumesPostAnonymous_uploadUpload_token,
    body: bodyPostAnonymous_uploadUpload_token
  }
}
export interface Anonymous_uploadUpload_token extends BaseRouteType {
  post: IPostAnonymous_uploadUpload_token
}